export default __webpack_public_path__ + "static/media/012-line-yellow.50b56d18.svg";